export const iconSizeVariants = {
  xxs: 6,
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 28,
  xxl: 64,
};
export type iconSize = keyof typeof iconSizeVariants;
